module.exports = __webpack_public_path__ + "static/media/carousel-img4.f975cdea.png";